import { useUserInfo } from "@/api/user";
import { ROUTES } from "@/constants/routes";
import { nativeLoginOpts } from "@/native/auth";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useLDClient } from "launchdarkly-react-client-sdk";
import React from "react";
import { Navigate } from "react-router-dom";

export function useIsLDReady(): boolean {
  const ldClient = useLDClient();

  return ldClient !== undefined;
}

export function useAppLoading() {
  const { isLoading: isAuth0Loading, isAuthenticated } = useAuth0();
  const isLDReady = useIsLDReady();

  const { isLoading: isLoadingUserInformation } = useUserInfo();

  return (
    isAuth0Loading ||
    (isAuthenticated && isLoadingUserInformation) ||
    !isLDReady
  );
}

const AuthenticationGuard = React.memo(
  ({ children }: { children: React.ReactNode }) => {
    const auth0 = useAuth0();
    const isLoading = useAppLoading();

    if (auth0.error) {
      return <Navigate to={ROUTES.AUTH.ERROR} />;
    }

    if (isLoading) {
      return null;
    }

    return children;
  },
);

export default React.memo(
  withAuthenticationRequired(AuthenticationGuard, {
    loginOptions: nativeLoginOpts(),
  }),
);
